import KitsPage from './KitsPage';

export default KitsPage;
